
/**
 * 组件封装
 * by 13
 */
function wrap(Ctor) {
  // 扩展
  return Ctor;
}
export default wrap;



// WEBPACK FOOTER //
// ./ui/vue-beauty/src/components/transfer/wrap.js